export{createComponent}from"./create-component.js";
//# sourceMappingURL=index.js.map
